import './App.css';
import React from 'react';
import Hero from './components/Hero';
import Company from './components/Companies';
import Feedback from './components/Feedback';
import Productivity from './components/Productivity';
import Revenue from './components/Revenue';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { FeedbackData } from './../src/components/feedbackData';


function App() {
  return (
    <div className="App">
     
      <Hero />  
      <Company />
      <Feedback slides={FeedbackData} />
      <Productivity />
      <Revenue />
      <Features />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
